const Reflux = require('@muzzylane/reflux');
const uuid = require('uuid');
const ServerRequest = require('./request');
const ErrorConsts = require('../constants/error');
const ForgeError = require('../util/error');
const AssetUtil = require('../util/asset');

const ActivityActions = Reflux.createActions({
    getActivity: { children: ['completed', 'failed'] },
    getProjectActivities: { children: ['completed', 'failed'] },
    getChannelActivities: { children: ['completed', 'failed'] },
    createActivity: { children: ['completed', 'failed'] },
    archiveActivity: { children: ['completed', 'failed'] },
    publishActivity: { children: ['completed', 'failed'] },
    publishIsBreaking: { children: ['completed', 'failed', 'reset'] },
    publishGetValidation: { children: ['completed', 'failed', 'reset'] },
    unpublish: { children: ['completed', 'failed'] },
    getValidationForVersion: { children: ['completed', 'failed'] },
    renameActivity: { children: ['completed', 'failed'] },
    setDescriptionActivity: { children: ['completed', 'failed'] },
    setPlayTextActivity: { children: ['completed', 'failed'] },
    transferActivity: { children: ['completed', 'failed'] },
    copyActivity: { children: ['completed', 'failed'] },
    updateActivityVersion: { children: ["completed"] },
    updateActivityAutoSaveInfo: { children: ["completed"] },
    addActivityImage: { children: ['completed', 'failed'] },
    getActivityFeatures: { children: ['completed', 'failed'] },
    getActivityLockStatus: { children: ['completed', 'failed'] },
    setDisplayName: { children: ['completed', 'failed'] },
    getActivityTags: { children: ['completed', 'failed'] },
    addActivityTag: { children: ['completed', 'failed'] },
    addActivityTags: { children: ['completed', 'failed'] },
    deleteActivityTag: { children: ['completed', 'failed'] },
    getActivitySaves: { children: ['completed', 'failed'] },
    getActivityStats:  { children: ['completed', 'failed'] },
    deleteAutosave: { children: ['completed', 'failed'] },
    forceUnlockActivity: { children: ['completed', 'failed'] },
    getActivityEditAccessInfo: { children: ['completed', 'failed'] },
    modifyShareLink: { children: ['completed', 'failed'] },
    getShareLinkUrl: { children: ['completed', 'failed'] },
    sendActivityNonAuthorFeedback: { children: ['completed', 'failed'] },
    getActMetaTagsForOrg: { children: ['completed', 'failed'] },
    getActMetaTagsForOrgViaAct: { children: ['completed', 'failed'] },
    getActivitiesForMetaTag: { children: ['completed', 'failed'] },
    addOrgActMetaTag: { children: ['completed', 'failed'] },
    deleteActMetaTag: { children: ['completed', 'failed'] },
    reorderActMetaTag: { children: ['completed', 'failed'] },
    updateActMetaTag: { children: ['completed', 'failed'] },
    getActMetaTagsForAct: { children: ['completed', 'failed'] },
    addActMetaTagToActById: { children: ['completed', 'failed'] },
    addActMetaTagsToActByIds: { children: ['completed', 'failed'] },
    addFreeFormActMetaTagToAct: { children: ['completed', 'failed'] },
    removeActMetaTagFromActById: { children: ['completed', 'failed'] },
    removeActMetaTagsFromActByIds: { children: ['completed', 'failed'] },

    getActMetaTypesForOrg: { children: ['completed', 'failed'] },
    getActMetaTypesForOrgViaAct: { children: ['completed', 'failed'] },
    getActivitiesForMetaType: { children: ['completed', 'failed'] },
    addOrgActMetaType: { children: ['completed', 'failed'] },
    deleteActMetaType: { children: ['completed', 'failed'] },
    updateActMetaType: { children: ['completed', 'failed'] },
    getActMetaTypeForAct: { children: ['completed', 'failed'] },
    addActMetaTypeToActById: { children: ['completed', 'failed'] },
    removeActMetaTypeFromActById: { children: ['completed', 'failed'] },
    
    getActivityScoreCategories: { children: ['completed', 'failed'] },
    reportActivityTest: { children: ['completed', 'failed'] },
    
    updateActShortCourseMetaData: { children: ['completed', 'failed'] },
});

ActivityActions.getActivity.listen(function(actionId, params) {
    const self = this;

    //error on actionId?
    if (!params.activityId) {
        console.log(params);
        this.failed(actionId, params.activityId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    ServerRequest.makeRequest(`/authoring/activities/${params.activityId}`, 'GET')
        .then(res => self.completed(actionId, params.activityId, res))
        .catch(err => self.failed(actionId, params.activityId, err));
});

ActivityActions.getProjectActivities.listen(function(actionId, params) {
    const self = this;

    if (!params.projectId || !params.channelId) {
        this.failed(actionId, params.projectId, params.channelId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    ServerRequest.makeRequest(`/authoring/project/${params.projectId}/activities`, 'GET')
        .then(res => self.completed(actionId, params.projectId, params.channelId, res))
        .catch(err => self.failed(actionId, params.projectId, params.channelId, err));
});

ActivityActions.getChannelActivities.listen(function(actionId, params) {
    const self = this;

    if (!params.channelId) {
        this.failed(actionId, params.channelId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }
    
    ServerRequest.makeRequest(`/authoring/channel/${params.channelId}/activities`, 'GET')
    //ServerRequest.makeRequest(`/authoring/channel/${params.channelId}/activities?legacy=1`, 'GET') // use this line in case psql activities title has not been filled in
        .then(res => self.completed(actionId, params.channelId, res))
        .catch(err => self.failed(actionId, params.channelId, err));
});

ActivityActions.createActivity.listen(function(actionId, params) {
    if (!params.title) {
        this.failed(actionId, params.projectId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS, uiRefs: ['input'] }));
        return;
    }
    let data = {
        moduleId: params.moduleId,
        activityTitle: params.title,
    }
    if (params.subtype) {
        data.subtype = params.subtype; // for KidCitizen vs Music of US redmine #6618
    }

    ServerRequest.makeRequest(`/authoring/projects/${params.projectId}/activities/create`, 'POST', JSON.stringify(data))
        .then(res => this.completed(actionId, params.projectId, res))
        .catch(err => this.failed(actionId, params.projectId, err));
});

ActivityActions.archiveActivity.listen(function(actionId, params) {
    const self = this;

    ServerRequest.makeRequest(`/authoring/activities/${params.activityID}/archive`, 'PUT')
        .then(function(res) {self.completed(actionId, res, params.projectID, params.activityID)})
        .catch(function(err) {self.failed(actionId, err)});
});

ActivityActions.publishActivity.listen(function(actionId, params) {
    const self = this;

    // force_bump_major should be true if there are breaking changes since last publish
    // otherwise publish_v2 will throw an error
    // use publish/is_breaking endpint to determine whether force_bump_major should be mandated
    ServerRequest.makeRequest(`/authoring/activities/${params.activityId}/publish_v2`, 'PUT', JSON.stringify({
        message: params.message,
        force_bump_major: params.forceBumpMajor,
        update_inactive_assignments: params.updateInactiveAssignments,
        update_active_assignments: params.updateActiveAssignments
    }))
    .then(res => self.completed(actionId, params.activityId, res))
    .catch(err => self.failed(actionId, params.activityId, err));
});

ActivityActions.publishIsBreaking.listen(function(actionId, params) {
    const self = this;

    if (params.refresh) {
        this.reset(params.activityId);
    }

    ServerRequest.makeRequest(`/authoring/activities/${params.activityId}/publish/is_breaking`, 'GET')
    .then(res => self.completed(actionId, params.activityId, res))
    .catch(err => self.failed(actionId, params.activityId, err));
});

ActivityActions.publishGetValidation.listen(function(actionId, params) {
    const self = this;

    if (params.refresh) {
        this.reset(params.activityId);
    }

    ServerRequest.makeRequest(`/authoring/activities/${params.activityId}/publish/validate`, 'GET')
    .then(res => self.completed(actionId, params.activityId, res))
    .catch(err => self.failed(actionId, params.activityId, err));
});

ActivityActions.unpublish.listen(function(actionId, params) {
    if (!params.activityId) {
        this.failed(actionId, params.activityId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    ServerRequest.makeRequest(`/authoring/activities/${params.activityId}/unpublish`, 'POST', JSON.stringify({}))
        .then(res => this.completed(actionId, params.activityId, res))
        .catch(err => this.failed(actionId, params.activityId, err));
});

ActivityActions.getValidationForVersion.listen(function(actionId, params) {
    const self = this;

    ServerRequest.makeRequest(`/authoring/activities/${params.activityId}/validate/${params.version}`, 'GET')
    .then(res => self.completed(actionId, params.activityId, params.version, res))
    .catch(err => self.failed(actionId, params.activityId, params.version, err));
});

ActivityActions.renameActivity.listen(function(actionId, params) {
    const self = this;

    if (!params.name) {
        this.failed(actionId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS, uiRefs: ['input'] }));
        return;
    }

    ServerRequest.makeRequest(`/authoring/activities/${params.activityID}/rename`, 'PUT', JSON.stringify({
            name: params.name
        }))
        .then(function(res) {self.completed(actionId, res, params.projectID, params.activityID, params.name)})
        .catch(function(err) {self.failed(actionId, err)});
});

ActivityActions.setDescriptionActivity.listen(function(actionId, params) {
    const self = this;

    let description = params.description || '';

    ServerRequest.makeRequest(`/authoring/activities/${params.activityID}/description`, 'PUT', JSON.stringify({
            description: description
        }))
        .then(function(res) {self.completed(actionId, res, params.projectID, params.activityID, description)})
        .catch(function(err) {self.failed(actionId, err)});
});

ActivityActions.setPlayTextActivity.listen(function(actionId, params) {
    const self = this;

    let playText = params.playText || 'Play Assignment';
    let resumeText = params.resumeText || 'Resume Assignment';

    ServerRequest.makeRequest(`/authoring/activities/${params.activityID}/play_button_text`, 'PUT', JSON.stringify({
            playText: playText,
            resumeText: resumeText
        }))
        .then(function(res) {self.completed(actionId, res, params.projectID, params.activityID, playText, resumeText)})
        .catch(function(err) {self.failed(actionId, err)});
});


ActivityActions.transferActivity.listen(function(actionId, params) {
    const self = this;

    ServerRequest.makeRequest(`/authoring/activities/${params.activityId}/transfer`, 'POST', JSON.stringify({
            projectID: params.toProjectId
        }))
        .then(res => self.completed(actionId, params.activityId, params.toProjectId, params.fromProjectId, res))
        .catch(err => self.failed(actionId, params.activityId, params.toProjectId, params.fromProjectId, err));
});

ActivityActions.copyActivity.listen(function(actionId, params) {
    if (!params.name) {
        this.failed(actionId, params.activityId, params.toProjectId, params.fromProjectId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS, uiRefs: ['input'] }));
        return;
    }

    if (!params.activityId || !params.toProjectId || !params.fromProjectId) {
        this.failed(actionId, params.activityId, params.toProjectId, params.fromProjectId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS} ));
        return;
    }

    ServerRequest.makeRequest(`/authoring/activities/${params.activityId}/copy`, 'POST', JSON.stringify({
            name: params.name,
            projectId: params.toProjectId,
            copyMetaTags: params.copyMetaTags,
        }))
        .then(res => this.completed(actionId, params.activityId, params.toProjectId, params.fromProjectId, res))
        .catch(err => this.failed(actionId, params.activityId, params.toProjectId, params.fromProjectId, err));
});

ActivityActions.updateActivityVersion.listen(function(actionId, params) {
    this.completed(actionId, params.projectId, params.activityId, params.version);
});

ActivityActions.updateActivityAutoSaveInfo.listen(function(actionId, params) {
    this.completed(actionId, params.projectId, params.activityId, params.autoSaveInfo);
});


ActivityActions.addActivityImage.listen(function(actionId, params, files) {
    const self = this;
    params['assetType'] = 'image';

    // has params.activityId, params.projectId

    ServerRequest.makeUploadRequest('/authoring/create_asset_activity_image', 'POST', params, files, AssetUtil.validateImageMimeType)
        .then(res => self.completed(actionId, params.activityId, res))
        .catch(err => self.failed(actionId, params.activityId, err));
});

ActivityActions.getActivityFeatures.listen(function(actionId, params) {
    const self = this;

    ServerRequest.makeRequest(`/authoring/activity/features/${params.novaActId}`, 'GET')
        .then(function(res) {self.completed(actionId, params.projectId, params.activityId, params.assignmentHash, res)})
        .catch(function(err) {self.failed(actionId, err)});
});

ActivityActions.getActivityLockStatus.listen(function(actionId, params) {
    const self = this;

    ServerRequest.makeRequest(`/authoring/activity/${params.activityId}/lock_status`, 'GET')
        .then(function(res) {self.completed(actionId, params.projectId, params.activityId, res)})
        .catch(function(err) {self.failed(actionId, err)});
});

ActivityActions.setDisplayName.listen(function(actionId, params) {
    const self = this;

    ServerRequest.makeRequest(`/authoring/activities/${params.activityID}/display_name`, 'PUT', JSON.stringify({
            display_name: params.displayName || ''
        }))
        .then(function(res) {self.completed(actionId, res, params.projectID, params.activityID, params.displayName)})
        .catch(function(err) {self.failed(actionId, err)});
});

ActivityActions.getActivityTags.listen(function(actionId, params) {
    const self = this;

    ServerRequest.makeRequest(`/authoring/activity/${params.activityId}/tag_v2`, 'GET')
        .then((res) => self.completed(actionId, params.activityId, res))
        .catch((err) => self.failed(actionId, err));
});

ActivityActions.addActivityTag.listen(function(actionId, params) {
    const self = this;

    ServerRequest.makeRequest(`/authoring/activity/${params.activityId}/tag`, 'PUT', JSON.stringify({
            tags: params.tagRecord.tag
        }))
        .then((res) => self.completed(actionId, params.activityId, params.tagRecord, res))
        .catch((err) => self.failed(actionId, err));
});

ActivityActions.addActivityTags.listen(function(actionId, params) {
    const self = this;

    ServerRequest.makeRequest(`/authoring/activity/${params.activityId}/tags`, 'PUT', JSON.stringify({
            tags: params.tagRecords.map(tagRecord => tagRecord.tag),
        }))
        .then(res => self.completed(actionId, params.activityId, params.tagRecords, res))
        .catch(err => self.failed(actionId, err));
});

ActivityActions.deleteActivityTag.listen(function(actionId, params) {
    const self = this;

    ServerRequest.makeRequest(`/authoring/activity/${params.activityId}/tag`, 'DELETE', JSON.stringify({
            tag: params.tagRecord.tag
        }))
        .then((res) => self.completed(actionId, params.activityId, params.tagRecord, res))
        .catch((err) => self.failed(actionId, err));
});

ActivityActions.deleteAutosave.listen(function(actionId, params) {
    const self = this;
    ServerRequest.makeRequest(`/authoring/activity/${params.activityId}/autosave`, 'DELETE', JSON.stringify({
        nova_act_id: params.nova_act_id,
        version: params.version,
    }))
    .then((res) => self.completed(actionId, params, res))
    .catch((err) => self.failed(actionId, err));
});

ActivityActions.forceUnlockActivity.listen(function(actionId, params) {
    const self = this;
    ServerRequest.makeRequest(`/authoring/activity/${params.id}/force_unlock`, 'POST', JSON.stringify({
        projectId: params.projectId,
        id: params.id, // forge activity id
        nova_act_id: params.nova_act_id,
        kickerName: params.kickerName,
        clientResponseToken: String(uuid.v4()),
    }))
    .then((res) => self.completed(actionId, params, res))
    .catch((err) => self.failed(actionId, err));
});

ActivityActions.getActivitySaves.listen(function(actionId, params) {
    const self = this;

    ServerRequest.makeRequest(`/authoring/activity/${params.activityId}/saves`, 'GET')
    .then(res => self.completed(actionId, params.activityId, res))
    .catch(err  => self.failed(actionId, err));
});

ActivityActions.getActivityStats.listen(function(actionId, params) {
    const self = this;
    ServerRequest.makeTaskRequest(`/authoring/activities/${params.novaActId}/stats/usage`, 'POST', JSON.stringify({}))
        .then(res => this.completed(actionId, params.activityId, res))
        .catch(err  => this.failed(actionId, params.activityId, err));
});

ActivityActions.getActivityEditAccessInfo.listen(function(actionId, params) {
    const self = this;

    ServerRequest.makeRequest(`/authoring/activity/${params.activityId}/edit_access`, 'GET')
    .then(res => self.completed(actionId, params.activityId, res))
    .catch(err  => self.failed(actionId, params.activityId, err));
});

ActivityActions.modifyShareLink.listen(function(actionId, params) {
    if (!params.actId) {
        this.failed(actionId, params.projectId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    if (typeof params.enableShare !== 'boolean') {
        this.failed(actionId, params.projectId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    let shareExpiresAt;
    if (typeof params.shareExpiresAt === 'string') {
        shareExpiresAt = params.shareExpiresAt;
    }
    else { // clear any existing expiration
        shareExpiresAt = null;
    }

    ServerRequest.makeRequest(`/authoring/activities/${params.actId}/share_link`, 'POST', JSON.stringify({
            enableShare: params.enableShare,
            shareExpiresAt: shareExpiresAt
        }))
        .then(res => this.completed(actionId, params.actId, res))
        .catch(err => this.failed(actionId, params.actId, err));
});

ActivityActions.getShareLinkUrl.listen(function(actionId, params) {
    if (!params.shareId) {
        this.failed(actionId, params.projectId, new ForgeError({ message: ErrorConsts.MISSING_PARAMS }));
        return;
    }

    ServerRequest.makeRequest(`/authoring/sample_activity/${params.shareId}`, 'GET')
        .then(res => this.completed(actionId, params.shareId, res))
        .catch(err => this.failed(actionId, params.shareId, err));
});

ActivityActions.sendActivityNonAuthorFeedback.listen(function(actionId, params) {
    const self = this;
    ServerRequest.makeRequest(`/authoring/activity/add_feedback_comment`, 'POST',JSON.stringify(params))
    .then(res => self.completed(actionId, params, res))
    .catch(err  => self.failed(actionId, params, err));
});

// Activity Meta Tags
// -- Org level

ActivityActions.getActMetaTagsForOrg.listen(function(actionId, params) {
    ServerRequest.makeRequest(`/authoring/organization/${params.orgId}/activity_tags`, 'GET')
        .then(res => this.completed(actionId, params.orgId, res))
        .catch(err => this.failed(actionId, params.orgId, err));
});

ActivityActions.getActMetaTagsForOrgViaAct.listen(function(actionId, params) {
    ServerRequest.makeRequest(`/authoring/organization/${params.orgId}/activity_tags/activities/${params.actId}`, 'GET')
        .then(res => this.completed(actionId, params.orgId, params.actId, res))
        .catch(err => this.failed(actionId, params.orgId, params.actId, err));
});

ActivityActions.getActivitiesForMetaTag.listen(function(actionId, params) {
    ServerRequest.makeRequest(`/authoring/organization/${params.orgId}/activity_tags/${params.tagId}/activities`, 'GET')
        .then(res => this.completed(actionId, params.orgId, params.tagId, res))
        .catch(err => this.failed(actionId, params.orgId, params.tagId, err));
});

ActivityActions.addOrgActMetaTag.listen(function(actionId, params) {
    ServerRequest.makeRequest(`/authoring/organization/${params.orgId}/activity_tags/${params.categoryId}`, 'PUT', JSON.stringify({
            tag: params.tag,
        }))
        .then(res => this.completed(actionId, res))
        .catch(err => this.failed(actionId, err));
});

ActivityActions.deleteActMetaTag.listen(function(actionId, params) {
    ServerRequest.makeRequest(`/authoring/organization/${params.orgId}/activity_tags/${params.tagId}`, 'DELETE')
        .then(res => this.completed(actionId, params.orgId, params.categoryId, params.tagId, res))
        .catch(err => this.failed(actionId, params.orgId, params.categoryId, params.tagId, err));
});

ActivityActions.reorderActMetaTag.listen(function(actionId, params) {
    ServerRequest.makeRequest(`/authoring/organization/${params.orgId}/activity_tags/${params.tagId}/reorder`, 'PATCH', JSON.stringify({
            display_order: params.displayOrder,
        }))
        .then(res => this.completed(actionId, res))
        .catch(err => this.failed(actionId, err));
});

ActivityActions.updateActMetaTag.listen(function(actionId, params) {
    ServerRequest.makeRequest(`/authoring/organization/${params.orgId}/activity_tags/${params.tagId}`, 'PATCH', JSON.stringify({
            tag: params.tag,
        }))
        .then(res => this.completed(actionId, res))
        .catch(err => this.failed(actionId, err));
});

// --Act level

ActivityActions.getActMetaTagsForAct.listen(function(actionId, params) {
    ServerRequest.makeRequest(`/authoring/activities/${params.actId}/activity_tags`, 'GET')
        .then(res => this.completed(actionId, params.actId, res))
        .catch(err => this.failed(actionId, params.actId, err));
});

ActivityActions.addActMetaTagToActById.listen(function(actionId, params) {
    ServerRequest.makeRequest(`/authoring/activities/${params.actId}/activity_tags/${params.tagId}`, 'PUT', JSON.stringify({}))
        .then(res => this.completed(actionId, params.actId, res))
        .catch(err => this.failed(actionId, params.actId, err));
});

ActivityActions.addActMetaTagsToActByIds.listen(function(actionId, params) {
    ServerRequest.makeRequest(`/authoring/activities/${params.actId}/activity_tags`, 'PUT', JSON.stringify({
            tag_ids: params.tagIds,
        }))
        .then(res => this.completed(actionId, params.actId, res))
        .catch(err => this.failed(actionId, params.actId, err));
});

ActivityActions.addFreeFormActMetaTagToAct.listen(function(actionId, params) {
    ServerRequest.makeRequest(`/authoring/activities/${params.actId}/activity_tags/category/${params.categoryId}`, 'PUT', JSON.stringify({
            tag: params.tag,
        }))
        .then(res => this.completed(actionId, params.actId, res))
        .catch(err => this.failed(actionId, params.actId, err));
});

ActivityActions.removeActMetaTagFromActById.listen(function(actionId, params) {
    ServerRequest.makeRequest(`/authoring/activities/${params.actId}/activity_tags/${params.tagId}`, 'DELETE', JSON.stringify({}))
        .then(res => this.completed(actionId, params.actId, params.categoryId, params.tagId, res))
        .catch(err => this.failed(actionId, params.actId, params.categoryId, params.tagId, err));
});

ActivityActions.removeActMetaTagsFromActByIds.listen(function(actionId, params) {
    ServerRequest.makeRequest(`/authoring/activities/${params.actId}/activity_tags`, 'DELETE', JSON.stringify({
            tag_ids: params.tagIds,
        }))
        .then(res => this.completed(actionId, params.actId, params.categoryId, params.tagIds, res))
        .catch(err => this.failed(actionId, params.actId, params.categoryId, params.tagIds, err));
});

// Activity Meta Types
// -- Org level
ActivityActions.getActMetaTypesForOrg.listen(function(actionId, params) {
    ServerRequest.makeRequest(`/authoring/organization/${params.orgId}/activity_meta_types`, 'GET')
        .then(res => this.completed(actionId, params.orgId, res))
        .catch(err => this.failed(actionId, params.orgId, err));
});

ActivityActions.getActMetaTypesForOrgViaAct.listen(function(actionId, params) {
    ServerRequest.makeRequest(`/authoring/organization/${params.orgId}/activity_meta_types/activities/${params.actId}`, 'GET')
        .then(res => this.completed(actionId, params.orgId, params.actId, res))
        .catch(err => this.failed(actionId, params.orgId, params.actId, err));
});

ActivityActions.getActivitiesForMetaType.listen(function(actionId, params) {
    ServerRequest.makeRequest(`/authoring/organization/${params.orgId}/activity_meta_types/${params.typeId}/activities`, 'GET')
        .then(res => this.completed(actionId, params.orgId, params.typeId, res))
        .catch(err => this.failed(actionId, params.orgId, params.typeId, err));
});

ActivityActions.addOrgActMetaType.listen(function(actionId, params) {
    ServerRequest.makeRequest(`/authoring/organization/${params.orgId}/activity_meta_types`, 'PUT', JSON.stringify({
            display_name: params.displayName,
        }))
        .then(res => this.completed(actionId, params.orgId, res))
        .catch(err => this.failed(actionId, params.orgId, err));
});

ActivityActions.deleteActMetaType.listen(function(actionId, params) {
    ServerRequest.makeRequest(`/authoring/organization/${params.orgId}/activity_meta_types/${params.typeId}`, 'DELETE')
        .then(res => this.completed(actionId, params.orgId, params.typeId, res))
        .catch(err => this.failed(actionId, params.orgId, params.typeId, err));
});

ActivityActions.updateActMetaType.listen(function(actionId, params) {
    ServerRequest.makeRequest(`/authoring/organization/${params.orgId}/activity_meta_types/${params.typeId}`, 'PATCH', JSON.stringify({
            display_name: params.displayName,
        }))
        .then(res => this.completed(actionId, params.orgId, params.typeId, res))
        .catch(err => this.failed(actionId, params.orgId, params.typeId, err));
});

// --Act level
ActivityActions.getActMetaTypeForAct.listen(function(actionId, params) {
    ServerRequest.makeRequest(`/authoring/activities/${params.actId}/activity_meta_types`, 'GET')
        .then(res => this.completed(actionId, params.actId, res))
        .catch(err => this.failed(actionId, params.actId, err));
});

ActivityActions.addActMetaTypeToActById.listen(function(actionId, params) {
    ServerRequest.makeRequest(`/authoring/activities/${params.actId}/activity_meta_types/${params.typeId}`, 'PUT', JSON.stringify({}))
        .then(res => this.completed(actionId, params.actId, res))
        .catch(err => this.failed(actionId, params.actId, err));
});

ActivityActions.removeActMetaTypeFromActById.listen(function(actionId, params) {
    ServerRequest.makeRequest(`/authoring/activities/${params.actId}/activity_meta_types/${params.typeId}`, 'DELETE', JSON.stringify({}))
        .then(res => this.completed(actionId, params.actId, res))
        .catch(err => this.failed(actionId, params.actId, err));
});

ActivityActions.getActivityScoreCategories.listen(function(actionId, activityId, version) {
    ServerRequest.makeRequest(`/authoring/activities/${activityId}/score_categories/${version||''}`, 'GET')
        .then(res => this.completed(actionId, activityId, res, version))
        .catch(err => this.failed(actionId, activityId, err));
});

ActivityActions.reportActivityTest.listen(function(params) {
    ServerRequest.makeRequest(`/authoring/activities/${params.activity_id}/test_result/${params.version||''}`, 'PUT', JSON.stringify(params))
        .then(res => this.completed(params, res))
        .catch(err => this.failed(params, err));
    
});

ActivityActions.updateActShortCourseMetaData.listen(function(actionId, activityId, changes) {
    ServerRequest.makeRequest(`/authoring/activities/${activityId}/short_course_meta_data`, 'PUT', JSON.stringify({changes}))
        .then(res => this.completed(actionId, activityId, res))
        .catch(err => this.failed(actionId, activityId, err));
    
});

module.exports = ActivityActions;
